import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { isPlainObject } from 'lodash';
export function getMediaProp(prop, values) {
  if (!prop || !values) {
    return undefined;
  }

  if (!isPlainObject(prop)) {
    return values[prop];
  }

  var mediaKeys = Object.keys(prop);
  var result = {};
  mediaKeys.forEach(function (item) {
    var propValue = prop[item];

    if (propValue) {
      result[item] = values[propValue];
    }
  });
  return result;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9nZXRNZWRpYVByb3AudHMiXSwibmFtZXMiOlsiaXNQbGFpbk9iamVjdCIsImdldE1lZGlhUHJvcCIsInByb3AiLCJ2YWx1ZXMiLCJ1bmRlZmluZWQiLCJtZWRpYUtleXMiLCJPYmplY3QiLCJrZXlzIiwicmVzdWx0IiwiZm9yRWFjaCIsIml0ZW0iLCJwcm9wVmFsdWUiXSwibWFwcGluZ3MiOiI7OztBQUFBLFNBQVNBLGFBQVQsUUFBOEIsUUFBOUI7QUFHQSxPQUFPLFNBQVNDLFlBQVQsQ0FBc0JDLElBQXRCLEVBQXFEQyxNQUFyRCxFQUE0RjtBQUNqRyxNQUFJLENBQUNELElBQUQsSUFBUyxDQUFDQyxNQUFkLEVBQXNCO0FBQ3BCLFdBQU9DLFNBQVA7QUFDRDs7QUFFRCxNQUFJLENBQUNKLGFBQWEsQ0FBQ0UsSUFBRCxDQUFsQixFQUEwQjtBQUN4QixXQUFPQyxNQUFNLENBQUNELElBQUQsQ0FBYjtBQUNEOztBQUVELE1BQU1HLFNBQVMsR0FBR0MsTUFBTSxDQUFDQyxJQUFQLENBQVlMLElBQVosQ0FBbEI7QUFDQSxNQUFNTSxNQUF3QixHQUFHLEVBQWpDO0FBRUFILEVBQUFBLFNBQVMsQ0FBQ0ksT0FBVixDQUFrQixVQUFBQyxJQUFJLEVBQUk7QUFDeEIsUUFBTUMsU0FBUyxHQUFJVCxJQUFELENBQXdCUSxJQUF4QixDQUFsQjs7QUFDQSxRQUFJQyxTQUFKLEVBQWU7QUFDYkgsTUFBQUEsTUFBTSxDQUFDRSxJQUFELENBQU4sR0FBZVAsTUFBTSxDQUFDUSxTQUFELENBQXJCO0FBQ0Q7QUFDRixHQUxEO0FBT0EsU0FBT0gsTUFBUDtBQUNEIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgaXNQbGFpbk9iamVjdCB9IGZyb20gJ2xvZGFzaCc7XG5pbXBvcnQgeyBNZWRpYSwgTWVkaWFLZXksIFVuaXRWYWx1ZSB9IGZyb20gJy4uL3R5cGVzJztcblxuZXhwb3J0IGZ1bmN0aW9uIGdldE1lZGlhUHJvcChwcm9wPzogc3RyaW5nIHwgTWVkaWE8c3RyaW5nPiwgdmFsdWVzPzogeyBba2V5OiBzdHJpbmddOiBVbml0VmFsdWUgfSkge1xuICBpZiAoIXByb3AgfHwgIXZhbHVlcykge1xuICAgIHJldHVybiB1bmRlZmluZWQ7XG4gIH1cblxuICBpZiAoIWlzUGxhaW5PYmplY3QocHJvcCkpIHtcbiAgICByZXR1cm4gdmFsdWVzW3Byb3AgYXMgc3RyaW5nXTtcbiAgfVxuXG4gIGNvbnN0IG1lZGlhS2V5cyA9IE9iamVjdC5rZXlzKHByb3ApIGFzIE1lZGlhS2V5W107XG4gIGNvbnN0IHJlc3VsdDogTWVkaWE8VW5pdFZhbHVlPiA9IHt9O1xuXG4gIG1lZGlhS2V5cy5mb3JFYWNoKGl0ZW0gPT4ge1xuICAgIGNvbnN0IHByb3BWYWx1ZSA9IChwcm9wIGFzIE1lZGlhPHN0cmluZz4pW2l0ZW1dO1xuICAgIGlmIChwcm9wVmFsdWUpIHtcbiAgICAgIHJlc3VsdFtpdGVtXSA9IHZhbHVlc1twcm9wVmFsdWVdO1xuICAgIH1cbiAgfSk7XG5cbiAgcmV0dXJuIHJlc3VsdDtcbn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/@utex/ui-kit/dist/utils/getMediaProp.js
// module id = 1744
// module chunks = 118